var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { classNames } from "../../../Util";
var PaginationButton = function (_a) {
    var text = _a.text, onClick = _a.onClick, disabled = _a.disabled;
    return (_jsx("button", __assign({ disabled: disabled, onClick: onClick, className: classNames("relative inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50", disabled ? "opacity-40" : "") }, { children: text })));
};
export default PaginationButton;
